import Icon from '../icon'
import _ from 'lodash'

const features = ['filled', 'outlined', 'outlinedPlus', 'plain', 'plainPlus']

export default {
  name: 'KTag',
  props: {
    type: {
      type: String,
      // primary, secondary, warning, danger, success, light, dark
      default: 'light',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    beforeClear: {
      type: Function,
    },
    // selected: {
    //   type: Boolean,
    //   default: false,
    // },
    rounded: {
      type: Boolean,
      default: false,
    },
    thin: {
      type: Boolean,
      default: false,
    },
    super: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 线框样式
    outlined: Boolean,
    // 线框plus样式
    outlinedPlus: Boolean,
    // 朴素
    plain: Boolean,
    // 朴素plus
    plainPlus: Boolean,
  },
  data() {
    return {
      clearIcon: 'times',
    }
  },
  computed: {
    inGroup() {
      const $parent = this.$parent
      return $parent && $parent.$options && $parent.$options.name === 'KTagGroup'
    },
    hasEvents() {
      return !_.isPlainObject(this.$listeners)
    },
    tag() {
      return this.hasEvents && !this.inGroup ? 'a' : 'div'
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    doneClear() {
      this.$emit('clear')
    },
    handleClear() {
      if (this.beforeClear && typeof this.beforeClear === 'function') {
        return this.beforeClear(this.doneClear)
      }
      this.doneClear()
    },
    renderClearButton() {
      if (!this.clearable) {
        return
      }

      if (this.$slots.clear) {
        return this.$slots.clear
      }

      return <a
        class="km-tag__icon km-tag-clear"
        onClick={this.handleClear}
      >
        <Icon icon={this.clearIcon}/>
      </a>
    },
  },
  render() {
    const style = {}
    if (this.color) {
      style.color = this.color
    }

    const css = {
      'km-tag': true,
      'km-tag--clearable': this.clearable,
      'km-tag--rounded': this.rounded,
      'km-tag--thin': this.thin,
      'km-tag--super': this.super,
    }

    const feature = _.kebabCase(_.find(features, feature => this[feature]) || 'filled')
    css[`km-tag--${this.type}`] = true
    css[`km-tag--${feature}`] = true

    if (this.type) {
      css[`km-tag--${this.type}`] = true
    }

    const attrs = {
      disabled: this.disabled,
    }

    if (!this.disabled) {
      attrs.tabindex = -1
    }

    const events = {
      mouseenter: () => {
        this.clearIcon = 'times-circle-s'
      },
      mouseleave: () => {
        this.clearIcon = 'times'
      },
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    const clearButton = this.renderClearButton()
    const content = this.$slots.default

    return (
      <this.tag {...data}>
        {
          this.icon
            ? <Icon
              class={{
                'km-tag__icon': true,
                'is-mr-4': content,
              }}
              name={this.icon}
            />
            : null
        }
        {content}
        {clearButton}
      </this.tag>
    )
  },
}
